import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import packageSlice from './slices/packageSlice';
import reviewSlice from './slices/reviewSlice';
import userSlice from './slices/userSlice';
import bannerSlice from './slices/bannerSlice';
import contactNumberSlice from './slices/contactNumberSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        package: packageSlice,
        reviews: reviewSlice,
        user: userSlice,
        banner: bannerSlice,
        contactNumbers: contactNumberSlice
    }
});

export default store;
